module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bb8"
  }, [_h('svg', {
    staticStyle: {
      "position": "absolute",
      "width": "0",
      "height": "0",
      "overflow": "hidden"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_h('defs', [_h('symbol', {
    attrs: {
      "id": "icon-heading-block",
      "viewBox": "0 0 32 32"
    }
  }, [_h('title', ["heading-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M15.983 7.828h-3.315v7.136h-6.766v-7.136h-3.326v16.592h3.326v-6.896h6.766v6.896h3.315v-16.592zM29.414 21.86h-6.971l-0.023-0.057 2.95-3.219q1.902-2.062 2.728-3.333t0.826-2.775q0-2.222-1.464-3.555t-4.027-1.333q-2.597 0-4.129 1.553t-1.475 3.797l0.023 0.068h3.235q0-1.298 0.598-2.079t1.748-0.78q1.037 0 1.6 0.667t0.564 1.716q0 0.787-0.49 1.705t-1.652 2.252l-5.365 5.755v2.177h11.322v-2.56z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-subheading-block",
      "viewBox": "0 0 32 32"
    }
  }, [_h('title', ["subheading-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M15.983 7.828h-3.315v7.136h-6.766v-7.136h-3.326v16.592h3.326v-6.896h6.766v6.896h3.315v-16.592zM21.452 17.204h1.868q1.276 0 1.931 0.609t0.655 1.918q0 1.093-0.667 1.731t-1.817 0.638q-1.048 0-1.732-0.618t-0.683-1.572h-3.224l-0.023 0.068q-0.057 2.233 1.6 3.457t3.969 1.224q2.586 0 4.243-1.305t1.657-3.585q0-1.345-0.724-2.36t-2.101-1.505q1.196-0.547 1.88-1.521t0.684-2.056q0-2.278-1.532-3.509t-4.107-1.231q-2.312 0-3.873 1.265t-1.492 3.212l0.023 0.068h3.223q0-0.889 0.638-1.437t1.572-0.547q1.082 0 1.652 0.604t0.57 1.607q0 1.106-0.57 1.727t-1.754 0.621h-1.868v2.496z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-text-block",
      "viewBox": "0 0 24 24"
    }
  }, [_h('title', ["text-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M14 17h-10v2h10v-2zM20 9h-16v2h16v-2zM4 15h16v-2h-16v2zM4 5v2h16v-2h-16z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-add-block",
      "viewBox": "0 0 24 24"
    }
  }, [_h('title', ["add-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M13 7h-2v4h-4v2h4v4h2v-4h4v-2h-4v-4zM12 2c-5.525 0-10 4.475-10 10s4.475 10 10 10 10-4.475 10-10-4.475-10-10-10zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-image-block",
      "viewBox": "0 0 24 24"
    }
  }, [_h('title', ["image-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M15.2 12c0 1.767-1.433 3.2-3.2 3.2s-3.2-1.433-3.2-3.2c0-1.767 1.433-3.2 3.2-3.2s3.2 1.433 3.2 3.2z"
    }
  }), " ", _h('path', {
    staticClass: "path2",
    attrs: {
      "d": "M9 2l-1.83 2h-3.17c-1.105 0-2 0.895-2 2v12c0 1.105 0.895 2 2 2h16c1.105 0 2-0.895 2-2v-12c0-1.105-0.895-2-2-2h-3.17l-1.83-2h-6zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-image-right",
      "viewBox": "0 0 32 32"
    }
  }, [_h('title', ["image-right"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M3.34 4.010h25.31v3.98h-25.31v-3.98zM28.65 24.040h-25.31v3.98h25.31v-3.98zM28.65 9.97h-11.61v12.070h11.61v-12.070zM14.96 9.973h-11.61v2.634h11.61v-2.634zM14.95 19.408h-11.61v2.634h11.61v-2.635zM14.96 14.791h-11.61v2.634h11.61v-2.634z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-image-center",
      "viewBox": "0 0 32 32"
    }
  }, [_h('title', ["image-center"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M3.34 4.010h25.31v3.98h-25.31v-3.98zM3.34 24.040h25.31v3.98h-25.31v-3.98zM3.34 9.97h25.31v12.070h-25.31v-12.070z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-image-left",
      "viewBox": "0 0 32 32"
    }
  }, [_h('title', ["image-left"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M3.34 4.010h25.31v3.98h-25.31v-3.98zM3.34 24.040h25.31v3.98h-25.31v-3.98zM3.34 9.97h11.61v12.070h-11.61v-12.070zM17.030 9.973h11.61v2.634h-11.61v-2.634zM17.040 19.408h11.61v2.634h-11.61v-2.635zM17.030 14.791h11.61v2.634h-11.61v-2.634z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-video-block",
      "viewBox": "0 0 24 24"
    }
  }, [_h('title', ["video-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M12 20.016c4.406 0 8.016-3.609 8.016-8.016s-3.609-8.016-8.016-8.016-8.016 3.609-8.016 8.016 3.609 8.016 8.016 8.016zM12 2.016c5.531 0 9.984 4.453 9.984 9.984s-4.453 9.984-9.984 9.984-9.984-4.453-9.984-9.984 4.453-9.984 9.984-9.984zM9.984 16.5v-9l6 4.5z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-gallery-block",
      "viewBox": "0 0 32 32"
    }
  }, [_h('title', ["gallery-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M3.351 4.039v10.386h11.608v-10.386h-11.608zM4.235 13.42l2.426-3.121 1.791 2.111 2.507-3.151 3.122 4.161zM17.041 4.039v10.386h11.608v-10.386h-11.608zM17.925 13.42l2.426-3.121 1.791 2.111 2.507-3.151 3.122 4.161zM3.351 16.493v10.387h11.608v-10.387h-11.608zM4.235 25.81l2.426-3.121 1.791 2.111 2.507-3.151 3.122 4.161zM17.041 16.493v10.387h11.608v-10.387h-11.608zM17.925 25.81l2.426-3.121 1.791 2.111 2.507-3.151 3.122 4.161z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-teaser-block",
      "viewBox": "0 0 32 32"
    }
  }, [_h('title', ["teaser-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M17.041 10.011v2.639h11.608v-2.639h-11.608zM17.041 14.72v2.639h11.608v-2.639h-11.608zM3.35 4.040v4.009h25.299v-4.009h-25.299zM3.351 10.010v12.059h11.608v-12.059h-11.608zM4.235 21l2.426-3.121 1.791 2.111 2.507-3.151 3.122 4.161zM3.35 24.14h25.299v2.639h-25.299v-2.639zM17.041 19.43h11.608v2.639h-11.608v-2.639z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-gist-block",
      "viewBox": "0 0 24 28"
    }
  }, [_h('title', ["gist-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M12 2c6.625 0 12 5.375 12 12 0 5.297-3.437 9.797-8.203 11.391-0.609 0.109-0.828-0.266-0.828-0.578 0-0.391 0.016-1.687 0.016-3.297 0-1.125-0.375-1.844-0.812-2.219 2.672-0.297 5.484-1.313 5.484-5.922 0-1.313-0.469-2.375-1.234-3.219 0.125-0.313 0.531-1.531-0.125-3.187-1-0.313-3.297 1.234-3.297 1.234-0.953-0.266-1.984-0.406-3-0.406s-2.047 0.141-3 0.406c0 0-2.297-1.547-3.297-1.234-0.656 1.656-0.25 2.875-0.125 3.187-0.766 0.844-1.234 1.906-1.234 3.219 0 4.594 2.797 5.625 5.469 5.922-0.344 0.313-0.656 0.844-0.766 1.609-0.688 0.313-2.438 0.844-3.484-1-0.656-1.141-1.844-1.234-1.844-1.234-1.172-0.016-0.078 0.734-0.078 0.734 0.781 0.359 1.328 1.75 1.328 1.75 0.703 2.141 4.047 1.422 4.047 1.422 0 1 0.016 1.937 0.016 2.234 0 0.313-0.219 0.688-0.828 0.578-4.766-1.594-8.203-6.094-8.203-11.391 0-6.625 5.375-12 12-12zM4.547 19.234c0.031-0.063-0.016-0.141-0.109-0.187-0.094-0.031-0.172-0.016-0.203 0.031-0.031 0.063 0.016 0.141 0.109 0.187 0.078 0.047 0.172 0.031 0.203-0.031zM5.031 19.766c0.063-0.047 0.047-0.156-0.031-0.25-0.078-0.078-0.187-0.109-0.25-0.047-0.063 0.047-0.047 0.156 0.031 0.25 0.078 0.078 0.187 0.109 0.25 0.047zM5.5 20.469c0.078-0.063 0.078-0.187 0-0.297-0.063-0.109-0.187-0.156-0.266-0.094-0.078 0.047-0.078 0.172 0 0.281s0.203 0.156 0.266 0.109zM6.156 21.125c0.063-0.063 0.031-0.203-0.063-0.297-0.109-0.109-0.25-0.125-0.313-0.047-0.078 0.063-0.047 0.203 0.063 0.297 0.109 0.109 0.25 0.125 0.313 0.047zM7.047 21.516c0.031-0.094-0.063-0.203-0.203-0.25-0.125-0.031-0.266 0.016-0.297 0.109s0.063 0.203 0.203 0.234c0.125 0.047 0.266 0 0.297-0.094zM8.031 21.594c0-0.109-0.125-0.187-0.266-0.172-0.141 0-0.25 0.078-0.25 0.172 0 0.109 0.109 0.187 0.266 0.172 0.141 0 0.25-0.078 0.25-0.172zM8.937 21.438c-0.016-0.094-0.141-0.156-0.281-0.141-0.141 0.031-0.234 0.125-0.219 0.234 0.016 0.094 0.141 0.156 0.281 0.125s0.234-0.125 0.219-0.219z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-tweet-block",
      "viewBox": "0 0 26 28"
    }
  }, [_h('title', ["tweet-block"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M25.312 6.375c-0.688 1-1.547 1.891-2.531 2.609 0.016 0.219 0.016 0.438 0.016 0.656 0 6.672-5.078 14.359-14.359 14.359-2.859 0-5.516-0.828-7.75-2.266 0.406 0.047 0.797 0.063 1.219 0.063 2.359 0 4.531-0.797 6.266-2.156-2.219-0.047-4.078-1.5-4.719-3.5 0.313 0.047 0.625 0.078 0.953 0.078 0.453 0 0.906-0.063 1.328-0.172-2.312-0.469-4.047-2.5-4.047-4.953v-0.063c0.672 0.375 1.453 0.609 2.281 0.641-1.359-0.906-2.25-2.453-2.25-4.203 0-0.938 0.25-1.797 0.688-2.547 2.484 3.062 6.219 5.063 10.406 5.281-0.078-0.375-0.125-0.766-0.125-1.156 0-2.781 2.25-5.047 5.047-5.047 1.453 0 2.766 0.609 3.687 1.594 1.141-0.219 2.234-0.641 3.203-1.219-0.375 1.172-1.172 2.156-2.219 2.781 1.016-0.109 2-0.391 2.906-0.781z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-remove",
      "viewBox": "0 0 24 24"
    }
  }, [_h('title', ["remove"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z"
    }
  })]), " ", _h('symbol', {
    attrs: {
      "id": "icon-upload",
      "viewBox": "0 0 24 24"
    }
  }, [_h('title', ["upload"]), " ", _h('path', {
    staticClass: "path1",
    attrs: {
      "d": "M5.016 18h13.969v2.016h-13.969v-2.016zM9 15.984v-6h-3.984l6.984-6.984 6.984 6.984h-3.984v6h-6z"
    }
  })])])]), " ", _h('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.output),
      expression: "output"
    }],
    staticClass: "bb8-output",
    attrs: {
      "name": _vm.config.name
    },
    domProps: {
      "value": _vm._s(_vm.output)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.output = $event.target.value
      }
    }
  }), " ", _h('div', {
    staticClass: "bb8-default-controls"
  }, [_h('controls', {
    attrs: {
      "index": -1,
      "block-types": _vm.blockTypes
    },
    on: {
      "add-block": _vm.addBlock
    }
  })]), " ", _vm._l((_vm.blocks), function(block, index) {
    return _h(block.blocktype + '-block', {
      key: block.id,
      tag: "component",
      attrs: {
        "index": index,
        "block": block,
        "config": _vm.config
      },
      on: {
        "remove-block": _vm.removeBlock
      }
    }, [_h('controls', {
      attrs: {
        "index": index,
        "block-types": _vm.blockTypes
      },
      on: {
        "add-block": _vm.addBlock
      }
    })])
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bcf6cd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Bb8.vue
// module id = 45
// module chunks = 0